/**
 * Header Account Dropdown
 * Handles toggle behavior for account dropdown menu
 */

class HeaderAccountDropdown {
  constructor() {
    this.container = document.querySelector('[data-header-account]');
    if (!this.container) return;

    this.trigger = this.container.querySelector('[data-header-account-trigger]');
    this.dropdown = this.container.querySelector('[data-header-account-dropdown]');

    if (!this.trigger || !this.dropdown) return;

    this.isOpen = false;
    this.init();
  }

  init() {
    // Initialize dropdown as closed but ready
    this.dropdown.setAttribute('data-open', 'false');

    // Toggle on click
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!this.container.contains(e.target) && this.isOpen) {
        this.close();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
        this.trigger.focus();
      }
    });

    // Keyboard navigation within dropdown
    this.dropdown.addEventListener('keydown', (e) => {
      this.handleKeyboardNav(e);
    });
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.trigger.setAttribute('aria-expanded', 'true');
    this.dropdown.setAttribute('data-open', 'true');

    // Focus first menu item
    const firstItem = this.dropdown.querySelector('.header-account__menu-item');
    if (firstItem) {
      setTimeout(() => firstItem.focus(), 100);
    }
  }

  close() {
    this.isOpen = false;
    this.trigger.setAttribute('aria-expanded', 'false');
    this.dropdown.setAttribute('data-open', 'false');
  }

  handleKeyboardNav(e) {
    const items = Array.from(this.dropdown.querySelectorAll('.header-account__menu-item'));
    const currentIndex = items.indexOf(document.activeElement);

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (currentIndex < items.length - 1) {
          items[currentIndex + 1].focus();
        } else {
          items[0].focus();
        }
        break;

      case 'ArrowUp':
        e.preventDefault();
        if (currentIndex > 0) {
          items[currentIndex - 1].focus();
        } else {
          items[items.length - 1].focus();
        }
        break;

      case 'Tab':
        // Close dropdown when tabbing out
        this.close();
        break;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeaderAccountDropdown();
  });
} else {
  new HeaderAccountDropdown();
}
